import React, { useState, useEffect } from 'react';
import { Tile, TileHeader, TileTitle, Checkbox, Button, withNavigation } from 'cantarus-react-ui';
import { AdminSettingsStrings as Strings, AdminPanelStrings, getModuleId } from '../../utils/config';
import * as adminSettingsApi from '../../api/templateAdminSettingsApi';
import Spinner from '../common/Spinner'
import './styles.css'

const AdminSettings = ({ templateId }) => {
    const [loading, setLoading] = useState(true);
    const [useAsExample, setUseAsExample] = useState(false);

    useEffect(() => {
        const checkIfExample = async () => {
            const exampleModuleId = await adminSettingsApi.getTemplateExampleModuleId(templateId);
            setUseAsExample(exampleModuleId === parseInt(getModuleId(), 10));
        }
        setTimeout(() => setLoading(false), 750);
        checkIfExample();

    }, [templateId]);

    const handleSave = () => {
        setLoading(true);

        const saveSettings = async () => {
            await adminSettingsApi.updateTemplateExample(templateId, getModuleId(), useAsExample)
        }

        setTimeout(() => setLoading(false), 750);
        saveSettings();
    }

    return (
        <Tile>
            <TileHeader>
                <TileTitle>{Strings.header}</TileTitle>
            </TileHeader>
            {
                loading ?
                    <Spinner /> :
                    <div className='td-admin-settings'>
                        <div className='td-admin-settings-example'>
                            <div className='td-admin-settings-option-title'>{Strings.exampleTitle}</div>
                            <Checkbox value={useAsExample} onChange={() => { setUseAsExample(!useAsExample) }} />
                        </div>
                        <div className='td-admin-settings-controls'>
                            <Button
                                onClick={handleSave}
                                text={Strings.saveSettingsButton}
                            />
                        </div>
                    </div>
            }
        </Tile >
    );

};

export const AdminNav = withNavigation(AdminSettings, 'admin', AdminPanelStrings.adminMenuLabel);
